import { Dropdown } from "react-bootstrap";
import styled from "styled-components";

const StyledToggle = styled(Dropdown.Toggle)<{ $isInvalid?: boolean }>`
  width: 285px;
  font-size: 10px;

  display: flex;
  align-items: center;
  justify-content: flex-start; /* ⬅ left align content */
  text-align: left; /* ⬅ ensure text is left aligned */

  /* keep the button from letting content spill out */
  overflow: hidden;

  /* Bootstrap caret */
  &::after {
    flex: 0 0 auto;
    margin-left: 8px;
  }

  /* the label text */
  .toggle-text {
    flex: 1 1 auto;
    min-width: 0; /* critical for ellipsis in flex */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  ${({ $isInvalid }) => $isInvalid && `outline: 2px solid red;`}
`;

export default StyledToggle;
